import { Component, Inject, PLATFORM_ID, OnInit } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AdService } from '../../services/ad.service';
import { LanguageService } from '../../services/language.service';

@Component({
  selector: 'app-cookie-consent',
  standalone: true,
  imports: [CommonModule, RouterModule],
  template: `
    <div class="cookie-banner" *ngIf="showBanner">
      <div class="content">
        <p>
          {{ t('cookie_message') }}
          <a [routerLink]="['/privacy-policy']" class="learn-more">{{ t('cookie_learn_more') }}</a>
        </p>
        <div class="actions">
          <button class="btn-decline" (click)="decline()">{{ t('cookie_decline') }}</button>
          <button class="btn-accept" (click)="accept()">{{ t('cookie_accept') }}</button>
        </div>
      </div>
    </div>
  `,
  styles: [`
    .cookie-banner {
      position: fixed;
      bottom: 0;
      left: 0;
      width: 100%;
      background: rgba(255, 255, 255, 0.95);
      backdrop-filter: blur(10px);
      border-top: 1px solid rgba(0,0,0,0.1);
      box-shadow: 0 -4px 20px rgba(0,0,0,0.05);
      z-index: 1000;
      padding: 1rem;
      animation: slideUp 0.5s ease-out;
    }
    .content {
      max-width: 1200px;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 1rem;
      text-align: center;
    }
    @media (min-width: 768px) {
      .content {
        flex-direction: row;
        justify-content: space-between;
        text-align: left;
      }
    }
    p {
      margin: 0;
      color: var(--text-dark);
      font-size: 0.8rem;
      line-height: 1.5;
    }
    .learn-more {
      color: var(--text-dark);
      text-decoration: underline;
      font-weight: 600;
      cursor: pointer;
      margin-left: 0.5rem;
    }
    .actions {
      display: flex;
      gap: 1rem;
    }
    button {
      padding: 0.5rem 1.5rem;
      border-radius: 50px;
      border: none;
      font-family: var(--font-family);
      font-weight: 600;
      cursor: pointer;
      transition: all 0.2s;
    }
    .btn-accept {
      background: var(--text-dark);
      color: white;
    }
    .btn-accept:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(0,0,0,0.15);
    }
    .btn-decline {
      background: #f0f0f0;
      color: var(--text-muted);
    }
    .btn-decline:hover {
      background: #e0e0e0;
    }

    @keyframes slideUp {
      from { transform: translateY(100%); }
      to { transform: translateY(0); }
    }
  `]
})
export class CookieConsentComponent {
  showBanner = false;

  constructor(
    private adService: AdService,
    private langService: LanguageService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      // Check if user has already made a choice
      if (this.adService.hasValidConsent() === null) {
        this.showBanner = true;
      }
    }
  }

  accept() {
    console.log("accepté")
    this.adService.setConsent(true);
    this.showBanner = false;
  }

  decline() {
    console.log("refusé")
    this.adService.setConsent(false);
    this.showBanner = false;
  }

  t(key: string): string {
    return this.langService.translate(key);
  }
}
